import { render, staticRenderFns } from "./semSinglePage.vue?vue&type=template&id=62b5543f&"
import script from "./semSinglePage.vue?vue&type=script&lang=js&"
export * from "./semSinglePage.vue?vue&type=script&lang=js&"
import style0 from "./semSinglePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports